import React from 'react';
import {
  Container,
  Grid,
  Col,
  Image,
  Title,
  Text,
  Box,
} from '@mantine/core';
import Web7 from '../assets/img/lotus-flower.png';
import { Helmet } from 'react-helmet-async';

const AboutUs: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>About Us</title>
        <meta
          name="description"
          content="FundReach is a pioneering crowdfunding platform that empowers individuals and organizations to raise funds for causes that matter most to them. With a local-first approach, FundReach provides tailored solutions to meet the unique fundraising needs of different countries."
        />
      </Helmet>

      <Box className="about-us">
        <Box className="our-story-section" py="xl">
          <Container size="lg" px="sm">
            {/* — Who We Are — */}
            <Grid gutter="md" mb="xl">
              <Col xs={12} md={4}>
                {/* you can add an aside/graphic here */}
              </Col>
              <Col xs={12} md={8}>
                <Title order={2} mb="sm" style={{marginLeft:"15px"}}>
                  Who We Are
                </Title>
                <Text style={{marginLeft:"15px"}}>
                  FundReach is a community-driven donation platform dedicated
                  to empowering local causes through genuine, selfless giving
                  from donors around the globe. Unlike traditional crowdfunding
                  platforms that offer rewards or equity, FundReach is solely
                  focused on donation-based fundraising—where every
                  contribution is an act of pure generosity. Our secure,
                  transparent platform bridges the gap between local fundraisers
                  and global donors by leveraging social media, multiple
                  payment options (mobile money, PayPal, bank transfers), and a
                  rigorous vetting process to ensure trust. Whether you’re
                  raising funds for personal needs, community projects, or
                  organizations, FundReach offers an easy-to-use, low-cost
                  solution that makes a real difference.
                </Text>
              </Col>
            </Grid>

            {/* — Our Story — */}
            <Grid gutter="md" mb="xl">
              <Col xs={12} md={8}>
                <Title order={2} mb="sm" style={{marginLeft:"15px"}}>
                  Our Story
                </Title>
                <Text style={{marginLeft:"15px"}}>
                  Born from the need for a more accessible and efficient way
                  to raise funds for important causes, FundReach combines the
                  best of traditional and modern fundraising methods. We
                  recognized that diverse payment preferences and regional
                  challenges require a local-first approach, so we built a
                  platform tailored to connect local fundraisers with donors
                  worldwide. Today, FundReach stands as a testament to the
                  power of community and innovation in transforming lives.
                </Text>
              </Col>
              <Col xs={12} md={4}>
                {/* optional graphic */}
              </Col>
            </Grid>

            {/* — Mission & Vision — */}
            <Grid gutter="md" mb="xl">
              <Col xs={12}>
                <Grid gutter="md">
                  <Col xs={12} sm={5}>
                    <Title order={3} mb="xs" style={{marginLeft:"15px"}}>
                      Our Mission
                    </Title>
                    <Text style={{marginLeft:"15px"}}>
                      To empower individuals, organizations and communities
                      worldwide by providing a secure, accessible, and
                      community-focused donation platform that meets diverse
                      fundraising needs.
                    </Text>
                  </Col>

                  <Col xs={12} sm={2} style={{ textAlign: 'center' }}>
                    <Image src={Web7} fit="contain" mx="auto" />
                  </Col>

                  <Col xs={12} sm={5}>
                    <Title order={3} mb="xs" style={{marginLeft:"15px"}}>
                      Our Vision
                    </Title>
                    <Text style={{marginLeft:"15px"}}>
                      To be the global leader in donation-based fundraising,
                      renowned for our local-first approach, transparency, and
                      innovative solutions that simplify and amplify the impact
                      of giving.
                    </Text>
                  </Col>
                </Grid>
              </Col>
            </Grid>

            {/* — The Need We Are Addressing — */}
            <Grid gutter="md">
              <Col xs={12}>
                <Title order={2} mb="sm" style={{marginLeft:"15px"}}>
                  The Need We Are Addressing
                </Title>
                <Text weight={700} color="#0e1a57" style={{marginLeft:"15px"}}>
                  Many people around the world struggle to raise funds for
                  important causes due to limited access to convenient
                  fundraising tools and payment methods. In countries like
                  Kenya, traditional fundraising methods such as community
                  gatherings and WhatsApp groups are prevalent. FundReach
                  addresses this need by offering a platform that integrates
                  these traditional methods with modern fundraising
                  capabilities, making it easier to reach a wider audience and
                  receive donations.
                </Text>
              </Col>
            </Grid>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default AboutUs;
